import { render, staticRenderFns } from "./SkeletonRawMaterialComponent.vue?vue&type=template&id=1b32c484&scoped=true&"
import script from "./SkeletonRawMaterialComponent.vue?vue&type=script&lang=js&"
export * from "./SkeletonRawMaterialComponent.vue?vue&type=script&lang=js&"
import style0 from "./SkeletonRawMaterialComponent.vue?vue&type=style&index=0&id=1b32c484&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b32c484",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
